"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"], ["\n  ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _propTypes = require("./propTypes");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledTitle = _styledComponents2.default.div(_templateObject, function (props) {
  return props.antiAliased && c.fontSmoothing();
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight;
});

var Title = function Title(props) {
  var antiAliased = false;
  var fontSize = void 0,
      fontWeight = void 0;

  switch (props.size) {
    case 1:
      antiAliased = true;
      fontSize = c.LARGE;
      fontWeight = c.FONT_WEIGHT_2;
      break;

    case 2:
      antiAliased = true;
      fontSize = c.LARGE;
      fontWeight = c.FONT_WEIGHT_1;
      break;

    case 3:
      fontSize = c.MEDIUM;
      fontWeight = c.FONT_WEIGHT_2;
      break;

    case 4:
      fontSize = c.MEDIUM;
      fontWeight = c.FONT_WEIGHT_1;
      break;

    case 5:
      fontSize = c.SMALL;
      fontWeight = c.FONT_WEIGHT_2;
      break;

    case 6:
      fontSize = c.SMALL;
      fontWeight = c.FONT_WEIGHT_1;
      break;

    case 7:
      fontSize = c.SMALLER;
      fontWeight = c.FONT_WEIGHT_2;
      break;

    case 8:
      fontSize = c.SMALLER;
      fontWeight = c.FONT_WEIGHT_1;
      break;

    default:
      fontSize = c.MEDIUM;
      fontWeight = c.FONT_WEIGHT_2;
  }

  return _react2.default.createElement(StyledTitle, _extends({
    antiAliased: antiAliased,
    fontSize: fontSize,
    fontWeight: fontWeight
  }, props));
};

Title.defaultProps = _propTypes.titleDefaultProps;
Title.propTypes = _propTypes.titlePropTypes;
exports.default = Title;